import { render, staticRenderFns } from "./CategorySorting.vue?vue&type=template&id=74d39cfe&scoped=true&"
import script from "./CategorySorting.vue?vue&type=script&lang=js&"
export * from "./CategorySorting.vue?vue&type=script&lang=js&"
import style0 from "./CategorySorting.vue?vue&type=style&index=0&id=74d39cfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d39cfe",
  null
  
)

export default component.exports